import React from 'react';
import { Link, useLocation } from 'react-router-dom';
/*ui*/
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
/*component*/
import Typography from "@material-ui/core/Typography";
import { appStyle } from "../theme/appStyle";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import Icon from "@material-ui/core/Icon";
import { getWishlistData, WL } from "../helpers/localStorage";
import _get from "lodash/get";
import LazyImage from "./LazyImage";
import getSuppotedFileType from "../helpers/getSuppotedFileType";
import { PAGES_SLUGS } from "../constants";
import listingCardGeneralStyles from "../theme/listingCardGeneralStyles";
import DetailsCarPrice from "./ContentBlocks/Cars/DetailsCarPrice";
import toLocale from '../helpers/toLocale';
import DetailsCarPriceBlue from "./ContentBlocks/Cars/DetailsCarPriceBlue";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    ...appStyle(theme),
    ...listingCardGeneralStyles(theme),
    imageContainer: {
        position: 'relative',
    },
    chipRow: {
        position: 'absolute',
        top: theme.spacing(1),
        left: theme.spacing(1),
        right: theme.spacing(1),
        zIndex: 1,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    sku: {
        color: theme.palette.colorDarkGrey,
        fontSize: '12px',
        fontWeight: 400,
        position: 'absolute',
        top: '0',
        left: '0',
        zIndex: 1,
    },
    chipBase: {
        display: 'inline-block',
        padding: '4px 8px',
        borderRadius: '4px',
        fontSize: '13px',
        fontWeight: 400,
        textTransform: 'none',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    blueChip: {
        ...appStyle(theme).chipBase,
        background: theme.palette.primary.dark,
    },
    chipEcobonus: {
        ...appStyle(theme).chipBase,
        background: "#52A30A",
        color: "#141414",
    },
    chipReady: {
        ...appStyle(theme).chipBase,
        background: "#4B7CC4",
        color: "#fff",
    },
    chipReserved: {
        ...appStyle(theme).chipBase,
        background: "#F8D200",
        color: "#141414",
    },
    chipUsedCar: {
        ...appStyle(theme).chipBase,
        background: "#b3b3b3",
        color: "#141414",
    },
    technicalDataDescription: {
        marginTop: theme.spacing(2),
        flex:"1 auto",
    },
    carName: {
        marginBottom: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
    },
    usedCarCard: {
        backgroundColor: theme.palette.grey[200]
    }
}));

function DetailedCarCardBlue(props) {
    const classes = useStyles();
    const location = useLocation();
    const carData = props.data;
    const isUsedCar = carData.car_type === 'UsedCar';
    const gridItemSize = isUsedCar ? 3 : 4;

    return (
        <Card elevation={0} className={`${classes.carCard} ${isUsedCar ? classes.usedCarCard : ''}`}>
            <Link to={{ pathname: `/${PAGES_SLUGS.DETAILS}/${carData.slug}`, state: { from: location.pathname } }} className={classes.linkDecoration}>
                <div className={`${classes.imageContainer}`}>
                    <Box position='relative'>
                        <LazyImage
                            src={getSuppotedFileType(_get(carData, "media[0].thumb", []))}
                            ratio={56}
                            isAnimated={true}
                            alt={carData.name}
                        />
                        {getWishlistData(WL.CAR).includes(carData.slug) &&
                            <div className={classes.wishlistHeart}>
                                <Icon className={`${classes.wlIcon} brand-icon-heart-fill`} />
                            </div>
                        }
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} className={classes.chipRow}>
                            <Box>
                                {(_get(carData, "rom_ref", false) && !isUsedCar) &&
                                    <Typography component={"div"} className={classes.sku}># {carData.rom_ref} </Typography>}

                                {(_get(carData, "cab_api_id", false) && isUsedCar) &&
                                    <Typography component={"div"} className={classes.sku}># {carData.cab_api_id}</Typography>}
                            </Box>
                            <Box display={"flex"} marginRight={2}>
                                <div className={`${classes.blueChip}`}>Blue Weeks</div>
                                {isUsedCar &&
                                    <div className={`${classes.chipUsedCar}`}>Auto rulate</div>
                                }
                                {_get(carData, "rezervat", false) &&
                                    <div className={`${classes.chipReserved}`}>Rezervat</div>
                                }
                                {(_get(carData, "ecobonus", false) || _get(carData, "ecobonus_bev", false)) &&
                                    <div className={`${classes.chipEcobonus}`}>Volvo Eco Bonus</div>
                                }
                                {(_get(carData, "car_type", false) === "Config") &&
                                    <div className={`${classes.chipReady}`}>Gata de comanda</div>
                                }
                            </Box>
                        </Box>

                    </Box>
                </div>
                <Box display={"flex"} flexDirection={"column"} flexGrow={1}>
                    <Box display={"flex"} flexDirection={"column"} flexGrow={1} p={2}>
                        <Typography className={`${classes.carName} ${classes.weight500}`}>
                            {_get(carData, "short_name", "")}
                        </Typography>
                        <Divider  />
                        <Grid container spacing={1} className={classes.technicalDataDescription}>
                            <Grid item xs={3} container
                                  direction="column"
                                  alignItems="center">
                                <span className={"brand-icon-medium brand-icon-fuel"}> </span>
                                <Typography variant={"caption"} align={"center"}>{carData.fuel}</Typography>
                            </Grid>
                            {!isUsedCar && (
                                <Grid item xs={gridItemSize} container
                                      direction="column"
                                      alignItems="center">
                                    <span className={"brand-icon-medium brand-icon-transmission"}> </span>
                                    <Typography variant={"caption"} align={"center"}>
                                        {carData.transmission_type && carData.transmission_type.length > 14
                                            ? carData.transmission_type.substring(0, 14)
                                            : carData.transmission_type
                                        }
                                    </Typography>
                                </Grid>
                            )}
                            <Grid item xs={gridItemSize} container
                                  direction="column"
                                  alignItems="center">
                                <span className={"brand-icon-medium brand-icon-traction"}> </span>
                                <Typography variant={"caption"} align={"center"}>
                                    {carData.transmission && carData.transmission.length > 14
                                        ? carData.transmission.substring(0, 14)
                                        : carData.transmission}
                                </Typography>
                            </Grid>

                            {isUsedCar && (
                                <>
                                    <Grid item xs={gridItemSize} container
                                          direction="column"
                                          alignItems="center">
                                        <span className={"brand-icon-medium brand-icon-speed"}> </span>
                                        <Typography variant={"caption"} align={"center"}>
                                            {toLocale(carData.km_purchase_date)}km
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={gridItemSize} container
                                          direction="column"
                                          alignItems="center">
                                        <span className={"brand-icon-medium brand-icon-factory"}> </span>
                                        <Typography variant={"caption"} align={"center"}>{carData.manufacturing_year}</Typography>
                                    </Grid>
                                </>
                            )}
                        </Grid>
                    </Box>
                    <Box bgcolor="primary.dark">
                        <Box display={"flex"}
                             alignItems={"center"}
                             justifyContent={"space-between"}
                             bgcolor="primary.dark"
                             p={2}
                        >
                            <Typography variant={'h5'} className={classes.whiteText}>
                                {DetailsCarPriceBlue(carData)}
                            </Typography>
                            <Typography variant={'caption'} className={classes.weight300}>
                                <span className={clsx("brand-icon-right-nav-arrow", classes.whiteText)}> </span>
                            </Typography>
                        </Box>
                    </Box>
{/*
                    <Box pt={1}
                         bgcolor="primary.dark"
                    >
                        <Box display={"flex"}
                             alignItems={"center"}
                             justifyContent={"space-between"}
                             pb={1.25}
                             px={3}
                        >
                            <Typography variant={'h5'} className={`${classes.weight300} ${classes.whiteText} ${classes.weight500}`}>
                                {DetailsCarPriceBlue(carData, false)}
                            </Typography>
                            <Typography variant={'caption'} className={`${classes.weight300}`}>
                                <span className={clsx("brand-icon-right-nav-arrow", classes.whiteText)}> </span>
                            </Typography>
                        </Box>
                    </Box>*/}
                </Box>
            </Link>
        </Card>
    );
}

export default DetailedCarCardBlue;
